var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferrals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32.00 32.00",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    fill: "#290000",
    stroke: "#290000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:none;stroke:#7d7d7d;stroke-width:1.7600000000000002;stroke-linejoin:round;stroke-miterlimit:10;} .st1{fill:none;stroke:#7d7d7d;stroke-width:1.7600000000000002;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;} .st2{fill:none;stroke:#7d7d7d;stroke-width:1.7600000000000002;stroke-miterlimit:10;} "), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 16,
    cy: 16,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 25.5,
    cy: 9.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 5.5,
    cy: 5.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 7.5,
    cy: 26.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 26.5,
    cy: 23.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 12.3,
    y1: 20.7,
    x2: 9.1,
    y2: 24.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 7.3,
    y1: 7.3,
    x2: 11.8,
    y2: 11.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 23.5,
    y1: 11,
    x2: 21,
    y2: 12.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 24.5,
    y1: 22,
    x2: 20.9,
    y2: 19.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferrals);
export default __webpack_public_path__ + "static/media/referrals.6ade691c26a487dbecb67da9bed8cb54.svg";
export { ForwardRef as ReactComponent };